import { SessionService } from '../services/session.service';

export function initializeSession(sessionService: SessionService) {
  return async (): Promise<void> => {
    // Only try to restore session if there's no OAuth callback in progress
    const hasOAuthCallback = new URLSearchParams(window.location.search).has('_et');
    const isAuthPage = window.location.pathname.includes('/auth') || window.location.pathname.includes('/login');
    
    // Don't try to restore session on auth pages or during OAuth callback
    if (!hasOAuthCallback && !isAuthPage) {
      await sessionService.tryRestoreSession();
    }
  };
}